import agilityArtwork from '../../assets/routine/agility.png'
import breathingArtwork from '../../assets/routine/breathing.png'
import resonanceArtwork from '../../assets/routine/resonance.png'
import warmupArtwork from '../../assets/routine/warmup.png'

import type { RoutineCategory } from './types'

export const normalizeRoutineCategory = (categoryName: string) =>
  categoryName
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()

export const getCategoryArtwork = (categoryName: string) => {
  const normalized = normalizeRoutineCategory(categoryName)

  if (normalized.includes('especial')) return breathingArtwork
  if (normalized.includes('chicas')) return warmupArtwork
  if (normalized.includes('chicos')) return resonanceArtwork
  if (normalized.includes('improvisa')) return agilityArtwork
  if (normalized.includes('respir')) return breathingArtwork
  if (
    normalized.includes('resonan') ||
    normalized.includes('liric') ||
    normalized.includes('legit')
  ) {
    return resonanceArtwork
  }
  if (
    normalized.includes('agil') ||
    normalized.includes('flex') ||
    normalized.includes('belt')
  ) {
    return agilityArtwork
  }
  return warmupArtwork
}

export const getRoutineTrackLabel = (title: string) =>
  title.replace(/\.mp3$/i, '')

export const getVisibleRoutineCategories = (routines: RoutineCategory[]) =>
  routines
    .map((routine) => ({
      ...routine,
      content: routine.content.filter((track) => track.visibility),
    }))
    .filter((routine) => routine.content.length > 0)
